import {selfAssessmentTargetScore} from 'stores/SelfAssessmentStore';

export default class SelfAssessmentUtil {

    static isLearningGoalAchieved(learningGoalId, activityModel) {

        // Get the main and resit task groups for the learning goal
        const learningGoal = activityModel.get('self_assessment').learning_goals.find(goal => goal.id === learningGoalId)
        const mainTaskGroupIds = []
        const resitTaskGroupIds = []
        for (const taskGroup of learningGoal.task_groups) {
            if (taskGroup.is_resit) {
                resitTaskGroupIds.push(taskGroup.id)
            } else {
                mainTaskGroupIds.push(taskGroup.id)
            }
        }

        let taskIds = []

        for (const taskGroupId of mainTaskGroupIds) {
            const taskGroup = activityModel.task_groups.get(taskGroupId)
            taskIds = taskIds.concat(taskGroup.tasks.pluck('id'))
        }

        // The target score is 100% of all the main tasks for the learning goal
        const targetScore = taskIds.length * selfAssessmentTargetScore

        for (const taskGroupId of resitTaskGroupIds) {
            const taskGroup = activityModel.task_groups.get(taskGroupId)
            taskIds = taskIds.concat(taskGroup.tasks.pluck('id'))
        }

        // The achieved score is the score of the student on all tasks for the learning goal
        let achievedScore = 0
        for (const response of activityModel.responses) {
            if (response.get('score') >= 0 && taskIds.includes(response.get('task_id'))) {
                achievedScore += response.get('score')
            }
        }

        return achievedScore >= targetScore
    }

    static getNextTaskGroupForLearningGoal(learningGoalId, activityModel) {

        // Get the main and resit task groups for the learning goal
        const learningGoal = activityModel.get('self_assessment').learning_goals.find(goal => goal.id === learningGoalId)
        const mainTaskGroupIds = []
        const resitTaskGroupIds = []
        for (const taskGroup of learningGoal.task_groups) {
            if (taskGroup.is_resit) {
                resitTaskGroupIds.push(taskGroup.id)
            } else {
                mainTaskGroupIds.push(taskGroup.id)
            }
        }

        // If there is a main task group without response, that is the next one
        for (const taskGroupId of mainTaskGroupIds) {
            const taskGroup = activityModel.task_groups.get(taskGroupId)
            for (const task of taskGroup.tasks) {
                if (!activityModel.responses.find({ task_id: task.id })) {
                    return taskGroup
                }
            }
        }

        // If there is a resit task group without response, that is the next one
        for (const taskGroupId of resitTaskGroupIds) {
            const taskGroup = activityModel.task_groups.get(taskGroupId)
            for (const task of taskGroup.tasks) {
                if (!activityModel.responses.find({ task_id: task.id })) {
                    return taskGroup
                }
            }
        }
    }

    static getNextTaskGroupForTeacher(selectedLearningGoals, activityModel, currentTaskGroupId) {

        const allowedTaskGroupIds = []
        for (const learningGoal of activityModel.get('self_assessment').learning_goals) {
            if (selectedLearningGoals.includes(learningGoal.id)) {
                for (const taskGroup of learningGoal.task_groups) {
                    allowedTaskGroupIds.push(taskGroup.id)
                }
            }
        }
        const currentIndex = allowedTaskGroupIds.indexOf(currentTaskGroupId)
        const nextTaskGroupId = allowedTaskGroupIds.at(currentIndex + 1)
        return activityModel.task_groups.get(nextTaskGroupId)

    }

    static removeResponsesForLearningGoal(learningGoalId, activityModel) {

        // Find out which task id's belong to the learning goal
        const learningGoal = activityModel.get('self_assessment').learning_goals.find(goal => goal.id === learningGoalId)
        const taskGroupIds = learningGoal.task_groups.map(taskGroup => taskGroup.id)
        const taskIds = []
        for (const taskGroupId of taskGroupIds) {
            for (const task of activityModel.task_groups.get(taskGroupId).tasks) {
                taskIds.push(task.id)
            }
        }

        // Remove responses for these tasks
        for (const taskId of taskIds) {
            const response = activityModel.responses.findWhere({ task_id: taskId })
            if (response) {
                activityModel.responses.remove(response, { silent: true })
            }
        }

    }

}
